import React from "react";
import { getCollection } from "services/portalApi";

export default function usePortalCollection(endpoint, responseKey) {
  const [data, setData] = React.useState([]);
  const [reloadVersion, setReloadVersion] = React.useState(0);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const reload = React.useCallback(() => setReloadVersion((version) => version + 1), []);

  React.useEffect(() => {
    const controller = new AbortController();
    async function load() {
      setLoading(true);
      setError(null);
      const collection = await getCollection(endpoint, responseKey, {
        signal: controller.signal,
        onError: setError,
      });
      if (!controller.signal.aborted) {
        setData(collection);
        setLoading(false);
      }
    }
    load();
    return () => controller.abort();
  }, [endpoint, responseKey, reloadVersion]);

  return [data, reload, { loading, error }];
}
